jQuery(function($){
  $(document).ready(function(){
    
     $(window).on('load',function(){
       var reviewUrl = window.location.href.indexOf("shopify-product-reviews");  
 
    if (reviewUrl >= 0) {
      
      $('#collapse5').addClass('in');
      $('#collapse5-mob').addClass('in');
      $('#heading5 a').attr('aria-expanded', 'true');
       $('#heading5 a').removeClass('collapsed');
       $('#collapse1').removeClass('in');
       $('#collapse1-mob').removeClass('in');
      $('#heading1 a').addClass('collapsed');
      $('#heading1 a').attr('aria-expanded','false');
      destination = $('#shopify-product-reviews').offset().top - 200;
      $('body,html').animate({
        scrollTop: destination
      }, 600);
      
       return false;
    }
    });
    
    /* if($('form.cart_preview').is(':visible')){
      $(document).mouseup(function(e) {
    	 var container = $("form.cart_preview");
		if (!container.is(e.target) && container.has(e.target).length === 0) {
      
     
         $('.cart_preview_inner').css('transform','translateX(0px)');
    
          $(container).css({
            "opacity": 1,
            "visibility": "visible"
          });
          
    	}
       });
       
     }*/
    
    
      $(function() {
    $( ".desk-acc1" ).accordion({
       collapsible: true,
       active: false,
       autoHeight: false
      });
     });
     $(function() {
      $( ".desk-acc2" ).accordion({
       collapsible: true,
       active: false,
       autoHeight: false
      });
     });
    
    //mobile cats accordion
   /*  $(".cat-lists .cat-link > a").on("click", function(e) {
       e.preventDefault();
       console.log('test');
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".sub-cats")
        .slideUp(200);
     
    } else {
     
     
      $(".cat-lists .cat-link > a").removeClass("active");
      $(this).addClass("active");
      $(".sub-cats").slideUp(200);
      $(this)
        .siblings(".sub-cats")
        .slideDown(200);
    }
  });*/
    
    //listen to the promo button click
    $('#redemDevPromo').on('click', function(event){
      //disable the button event
      event.preventDefault();
     
      
       var theDiscount = $('#devPromo').val();
       
       if(theDiscount != '') {       
        var action = $('#cartForm').attr('action');
         
         action = action.replace("discount=", "discount="+theDiscount);
         action = action.replace("/cart", "/checkout");
         $('#cartForm').attr('action', action);
         
          window.location.href = action;
       }
      
      
    });
    
     $('#checkout-button').on('click', function(event){
    	// commented as this prevents the form from submitting
      	// event.preventDefault();
       
      	  var theDiscount = $('#devPromo').val();
       
           if(theDiscount != '') {       
            var action = $('#cartForm').attr('action');

             action = action.replace("discount=", "discount="+theDiscount);
             $('#cartForm').attr('action', action);
           }
       
     });
    
    
  });
  
  
 
  
  $('.toggle-discount').click(function(e){
    e.preventDefault(); 
    $('.showform').slideToggle();
  });
  
  $('.filter_toggle').click(function(e){
    $('.prod-left-sidebar').slideToggle();
  });
    $(window).scroll(function(){
        if ($(this).scrollTop() > 300 ) {
            $('#shopify-section-header').addClass('fixed-header');
        }
        else {
            $('#shopify-section-header').removeClass('fixed-header');
         // $('.mega_menu_container').removeClass('menu-item-active');
        }
    });
  $(window).scroll(function(){
        if ($(this).scrollTop() > 150 ) {
          
          $('.header-top').addClass('fixed-header-mob');
        }
        else {
         
           $('.header-top').removeClass('fixed-header-mob');
        }
    });
  
  $('.show-search').click(function(e){
    e.preventDefault();
    $(this).toggleClass('active');
  });
    $(document).ready(function() {
     
      
      if($('.prod-options input[type="radio"]').is(':checked')){
         if($('.prod-options input[type="radio').hasClass('nostock')){
        	 var variantValue = $('.prod-options input[type="radio').val();
         
        	$('.etabtn').attr('value', variantValue);
         	$('.etabtn').show();
          
         }
        
        
       }
      $('.prod-options[data-option-index="0"] input').change(function(){
         var variant = $(this);
        
        if($(variant).is(':checked')){
        	 var variantValue = $(variant).val();
        	$('.etabtn').attr('value', variantValue);
         
        }
        
        
      });
       $('.prod-options[data-option-index="1"] input').change(function(){
         var variant = $(this);
        
        if($(variant).is(':checked')){
        	 var variantValue = $(variant).val();
        	$('.etabtn').attr('option', variantValue);
         
        }
        
        
      });
      
     
     
  if($.cookie("cookie-pop") == undefined){
           
      $.cookie("cookie-pop","cookie-cookie-pop",{ expires: 30 });

      $('.cookie-pop').show();
      $('.cookie-pop .close-pop').click(function (e) {
        e.preventDefault();
         $('.cookie-pop').hide();
      }); 
  }
    });

  /* product request ETA */
  	$('.etabtn').click(function(){
     
       $('#etaModal').modal('show');

    }, 3000);
  
 	 $('#etaModal').on('show.bs.modal', function (event) {
     
    	var getsku = $('.variant-sku').text();
       var getVariant = $('.etabtn').attr('value');
       var getVariant2 = $('.etabtn').attr('option');
       var fname = $('#fname').attr('value');
        var lname = $('#lname').attr('value');
        var phone = $('#phone_number').attr('value');
        var email = $('#email_address').attr('value');
       
       $('#etaModal input[name="nf_first_name"]' ).val(fname);
       $('#etaModal input[name="nf_last_name"]' ).val(lname);
       $('#etaModal input[name="nf_phone"]' ).val(phone);
       $('#etaModal input[name="nf_email"]' ).val(email);
       if(getVariant2 == null ){
         $('#etaModal input[name="nf_subject"]' ).val('Request on ETA for SKU:' + getsku + ' | Variant Title:' + getVariant);
     
       } else{
       	$('#etaModal input[name="nf_subject"]' ).val('Request on ETA for SKU:' + getsku + ' | Variant Title:' + getVariant + getVariant2);
       }
       
       
      });
  
  
   
   /* if($(".sticky-sidebar").length != 0){


     var $window = $(window);  
      var $sidebar = $(".sticky-sidebar"); 
      var $sidebarHeight = $sidebar.height();   
      var $footerOffsetTop = $(".related-products-section").offset().top ; 
      var $sidebarOffset = $sidebar.offset();
      var sidebarWidth = $('.prod-sidebar').width();
      var $leftContHeight = $('.prod-left .product-data').height() + 350;
      var $rightContHeight = $('.prod-sidebar').height();

      $window.scroll(function() {
        console.log( "window: " +  $window.scrollTop());
        console.log("footer: " + $footerOffsetTop);
        console.log("sidebar: " + $sidebarOffset.top);
        if($window.scrollTop() > $sidebarOffset.top && $window.scrollTop() < $leftContHeight) {
          $sidebar.addClass("fixed");   
        }else {
          $sidebar.removeClass("fixed");   
        }    
        if($window.scrollTop() > $footerOffsetTop) {
          $sidebar.css({"top" : -($window.scrollTop() + $sidebarHeight - $footerOffsetTop)});        
        } else {
          $sidebar.css({"top": "0",  width : sidebarWidth});  
        }    
      });   


       $(window).bind('load resize', function () {
          var sidebarWidth = $('.prod-sidebar').width();
          $(window).scroll(function(){
            $('.sticky-sidebar').css('width', sidebarWidth);

            });
        });
  }*/
  
  
  $('.options-list input').change(function(){
    if($(this).hasClass('nostock')){
    	$('.etabtn ').addClass('show');
    }else{
      $('.etabtn ').removeClass('show');
    }
  });
  
  $('.support').click(function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $('.wsmenu-list > li').removeClass('menu-item-active');
   
  });
   $('.wsmenu-list > li > a.twin').click(function(e){
    e.preventDefault();
    $('.support').removeClass('active');
   
  });
    if(typeof $.fn.flexslider === "function"){
         $('#flexslider').flexslider({
            animation: "fade",
            slideshowSpeed: 3000
        });
        $('[id^=flexslide]').flexslider({
            animation: "fade",
           slideshowSpeed: 3000
        });
        $('[id^=singleProductSlide]').flexslider({
            animation: "fade",
            controlNav: "thumbnails",
            directionNav: false
        });
    }
    
   /* $(".prod-options .options-list > li input[type=radio]").change(function(){
        if($(this).hasClass('enable-eta')){
            $(this).parents(".single-product-section").find(".btn-hollow").fadeIn();
        }else{
            $(this).parents(".single-product-section").find(".btn-hollow").fadeOut();
        }
    });*/
  if($('[data-toggle="tooltip"]').length > 0 ){
     $('[data-toggle="tooltip"]').tooltip();
  }
   
    
    $(".mobile-toggle").click(function(e){
        e.preventDefault();
        $("body").toggleClass("menu-open");
    });
    
//    setTimeout(function(){
//        $('#showOnLoad').modal('show');
//    }, 3000);
    
    $(".mobile-menu .wsmenu-list > li.mega_menu_container > a").click(function(e){
        e.preventDefault();
        $(this).siblings(".submenu-mega").slideToggle();
    });
    
   /* $(".custom-checkbox-group input[type='radio']").change(function(){
        if($(this).val() === "retailCheckbox"){
            $(".condition-action").fadeIn();
        }else{
            $(".condition-action").fadeOut();
        }
    });*/
    
    // header menu
    $(".wsmenu-list > li.mega_menu_container > a.twin").click(function(e){
        e.preventDefault();
        $(this).parent("li").siblings().removeClass("menu-item-active");
        $(this).parent("li").toggleClass("menu-item-active");
    });
    $(".prods-left-side-menu li").click(function(e){
        e.preventDefault();
        let menuItem = $(this).attr("data-menuitem");
        $(this).siblings().removeClass("main-actve");
        $(this).addClass("main-actve");
        $(".mgm-level-3").removeClass("mgm-active");
        $(".mgm-level-3[data-id=" + menuItem + "]").addClass("mgm-active");
    });
  
  	$(".wsmenu-list .mega_menu_container_child > a.twin").click(function(e){
        e.preventDefault();
        $(this).parent("div").siblings().removeClass("menu-item-active");
        $(this).parent("div").toggleClass("menu-item-active");
    });
  if( $(".blog-p-articles .products-slider").length > 0){
        $(".blog-p-articles .products-slider").owlCarousel({
            loop:false,
            nav: false,
            dots: false,
          autoplay :false,
         
            responsive:{
                0:{
                    items:1,
                  center:true,
                   margin:20,
                  dots: true,
                  loop:true,
                },
              	480:{
                    items:2,
                  center:true,
                   margin:20,
                  dots: true,
                  loop:true,
                },
              	768:{
                    items:2,
                  center:true,
                   margin:20,
                  dots: true,
                  loop:true,
                },
                1024:{
                    items:4,
                   margin:20,
                  center:false,
                  loop:false,
            		nav: false,
                  dots:false
                }
            }
        });
    }

  if( $(".blogslider").length > 0){
        $(".blogslider").owlCarousel({
            loop:true,
            nav: false,
            dots: true,
          autoplay :true,
         
            responsive:{
                0:{
                    items:2,
                  center:true,
                   margin:10,
                  dots: false,
                  loop:true,
                },
                768:{
                    items:3,
                   margin:30,
                  center:false,
                },
                992:{
                    items:3,
                   margin:10
                }
            }
        });
    }

 	if( $(".reasons-row").length > 0){
        $(".reasons-row").owlCarousel({
            loop:false,
            nav: false,
            dots: false,
            responsive:{
              
                0:{
                    items:2,
                   center:true,
                   margin:10,
                  dots: true,
                  loop:true,
                },
                768:{
                    items:3,
                  dots: false,
                  center:false,
                   margin:0,
                  loop:false,
                }
            }
        });
    }
    if( $(".js-partners-carousel").length > 0){
        $(".js-partners-carousel").owlCarousel({
            loop:true,
            margin:10,
            nav: true,
            dots: false,
            responsive:{
              
                0:{
                    items:3,
                  center: false ,
                  nav: false,
           			 dots: true,
                },
              	768:{
                  items:4,
                   nav: true,
            		dots: false,
                },
                992:{
                  items:5,
                   nav: true,
            		dots: false,
                },
                
                1250:{
                    items:6,
                   nav: true,
           		   dots: false,
                }
            }
        });
    }
   if( $(".js-products-slider").length > 0){
        $(".js-products-slider").owlCarousel({
            loop:true,
            margin:10,
            nav: false,
            dots: true,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:2
                },
                1000:{
                    items:3
                },
                1250:{
                    items:4
                }
            }
        });
   }
   if( $(".js-products-slider-2").length > 0){
        $(".js-products-slider-2").owlCarousel({
            loop:true,
            margin:10,
            nav: false,
            dots: true,
            items:1
        });
   }
     if( $(".js-quotes-slider").length > 0){
        $(".js-quotes-slider").owlCarousel({
            loop:true,
            margin:10,
            nav: false,
            dots: true,
            items: 1,
            autoplay :true,
            autoHeight:true
        });
    }
  if( $(".js-discounts-slider").length > 0){
  	$(".js-discounts-slider").owlCarousel({
            loop: true,
            items:1,
      		autoplay :true,
            autoHeight:true,
        });
     }
    // Page Scrolling
    $("a.anchor, a.target").click(function (e) {
        e.preventDefault();
        elementClick = $(this).attr("href");
        if($(elementClick).length){
            destination = $(elementClick).offset().top;
            $('body,html').animate({
                scrollTop: destination
            }, 600);
        }
    });
    
    // footer accordion    
    if($(window).width() <= 991){
        $(".footer-widgetarea .widget ul").hide();
    }else{
        $(".footer-widgetarea .widget ul").show();
    }
    $(window).resize(function(){
        if($(this).width() <= 991){
            $(".footer-widgetarea .widget ul").hide();
            $(".footer-widgetarea .widget h5").removeClass("is-active");
        }else{
            $(".footer-widgetarea .widget ul").show();
        }
    });
    $(".footer-widgetarea .widget h5").click(function(){
        if($(window).width() <= 991){
            $(this).toggleClass("is-active");
            $(this).next("ul").slideToggle();
        }
    });
    //account mobile updates
    $(window).resize(function(){
        if($(this).width() <= 767){
            $(".bottom-user .acct-nav .articles-card ul").hide();
            $(".bottom-user .acct-nav .articles-card  h3").removeClass("is-active");
        }else{
            $(".bottom-user .acct-nav .articles-card ul").show();
        }
    });
  
   $(".bottom-user .acct-nav .articles-card  h3").click(function(){
        if($(window).width() <= 767){
            $(this).toggleClass("is-active");
            $(this).next("ul").slideToggle();
        }
    });

  if( $(".offers-slider").length > 0){
   
        $(".offers-slider").owlCarousel({
            loop:true,
            margin:10,
            nav: true,
            dots: false,
            responsive:{
              
                0:{
                    items:2,
                  center: true,
                  nav: false,
           			 dots: false,
                  autoplay :true,
                  margin:10,
                  autoWidth :true
                  
                },
              	768:{
                  items:3,
                   nav: false,
            		dots: false,
                  center: false ,
                }
            }
        });
    }
  
    
});